const satReportApiBaseUrl = __SAT_REPORTS_API_URL__;

export const ApiEndpoints = {
  GetFeatureNamesAsync: `${satReportApiBaseUrl}/api/v1/satreports/FeatureFlag/GetFeatureNamesAsync`,
  GetIsEnabledByFeatureName: `${satReportApiBaseUrl}/api/v1/satreports/FeatureFlag/GetIsEnabledByFeatureName?featureName=`,
  ReportList: `${satReportApiBaseUrl}/api/v1/satreports/ReportView/ReportList`,
} as const;

export const Messages = {
  AccessDenied: 'Access Denied',
  AccessDeniedMessage: 'You don\'t have permission to access the Security module.',
  SatReportsAccessDeniedMessage: 'You don\'t have permission to access SAT Reports.',
  PageNotFound: '404 - Page Not Found',
  PageNotFoundMessage: 'The page you are looking for doesn\'t exist',
  ReportList_Error_Message: 'Something went wrong while retrieving Report List data.',
  IFT: 'IFT',
  SatReports: 'SAT Reports',
  AdminUpload: 'Admin Upload',
  PacketGeneration: 'Packet Generation',
  FeatureFlagByName_Retrieve_Error_Message: 'Something went wrong while retrieving feature by name.',
  FeatureFlag_Retrieve_Error_Message: 'Something went wrong while retrieving feature flags.',
} as const;